import _ from 'underscore'
import httpClient from '@src/services/http.service';

const getRating = review => review.rating

const calculateAverageReviewRating = reviews => {
  const ratings = reviews.map(getRating)
  return ratings.reduce((first, second) => (first + second)) / ratings.length
}

const actions = {
  init: ({ commit }) => {
    Promise.all([httpClient.get('review/approved'), httpClient.get('/review/card')])
    .then(([reviews, cards]) => {
      commit('SET_REVIEWS', reviews.data)
      commit('SET_CARDS', cards.data)
      commit('SET_AVERAGE_RATING', calculateAverageReviewRating(reviews.data))
    })
  },
  sendReview: (context, data) => {
    httpClient.post('review', data)
  },
  subscribeEmail: (context, data) => {
    const email = { email: data }
    httpClient.post('email/signup', email)
  },
}

const mutations = {
  SET_REVIEWS: (state, reviews) => {
    state.reviews = reviews
  },
  SET_CARDS: (state, cards) => {
    state.cards = cards
  },
  SET_AVERAGE_RATING: (state, rating) => {
    state.averageRating = rating
  }
}

const state = {
  reviews: [],
  cards: [],
  averageRating: null
}

const getters = {
  fifteenRandomReviews: state => _.sample(state.cards, 15),
  reviewsList: state => state.reviews,
  reviewsCards: state => state.cards,
  filteredReviews: state => id => state.reviews.filter(review => review.attraction === id),
  averageRating: state => state.averageRating
}

export default {
  actions,
  mutations,
  getters,
  state
}
